import React, { useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SivaContractCreateDto } from 'src/api/v2';
import { SivaPhase } from 'src/api/v2';
import { FormStepButtons } from '../FormStepButtons';
import { Fieldset, Label, Radio, useRadioGroup } from '@innovationnorway/cl-react';

type Props = {
  form: UseFormReturn<SivaContractCreateDto>;
  availablePhases: ReadonlyArray<SivaPhase>;
  stepForward: (() => void) | undefined;
  stepBackward: (() => void) | undefined;
};

const SelectPhase = ({ form, availablePhases, stepBackward, stepForward }: Props) => {
  const { t: tSiva } = useTranslation('siva');
  const phase = form.watch('sivaPhase');
  const phaseOptions = useMemo(
    () =>
      availablePhases.map((key) => ({
        text: tSiva(`phase.${key}`),
        value: key,
        selected: phase === key,
      })),
    [tSiva, phase, availablePhases],
  );

  const { getRadioProps } = useRadioGroup({
    name: 'sivaPhase',
    onChange: (value) => form.setValue('sivaPhase', value as SivaPhase),
    value: form.getValues('sivaPhase'),
  });

  return (
    <>
      <div className="margin-bottom--ds-4">
        <Label data-size="md">{tSiva('phase.select')}</Label>
      </div>
      <Fieldset className="select-phase--fieldset">
        {phaseOptions.map((option) => {
          return (
            <Radio
              key={option.value}
              label={option.text}
              name="sivaPhase"
              {...getRadioProps({ value: option.value })}
            />
          );
        })}
      </Fieldset>
      {stepForward && stepBackward && (
        <FormStepButtons stepForward={stepForward} stepBackward={stepBackward} stepForwardDisabled={!phase} />
      )}
    </>
  );
};

export default SelectPhase;
